export interface Viewport {
  center: [number, number];
  zoom: number;
}

/** 5dp ≈ 1m, and 0.1 zoom steps — the precision both stores round to.
 *  Shared so a viewport written by one tab compares equal in the other. */
export function normalize(center: [number, number], zoom: number): Viewport {
  return {
    center: [Math.round(center[0] * 1e5) / 1e5, Math.round(center[1] * 1e5) / 1e5],
    zoom: Math.round(zoom * 10) / 10,
  };
}

export const same = (a: Viewport | null | undefined, b: Viewport | null | undefined): boolean => {
  if (!a || !b) return false;
  return a.center[0] === b.center[0] && a.center[1] === b.center[1] && a.zoom === b.zoom;
};

/** Runtime guard for localStorage and URL parser. */
export function parse(raw: unknown): Viewport | null {
  const v = raw as Partial<Viewport> | null;
  if (!v || !Array.isArray(v.center) || v.center.length !== 2) return null;
  if (typeof v.center[0] !== 'number' || typeof v.center[1] !== 'number') return null;
  if (!Number.isFinite(v.center[0]) || !Number.isFinite(v.center[1])) return null;
  if (typeof v.zoom !== 'number' || !Number.isFinite(v.zoom)) return null;
  return normalize([v.center[0], v.center[1]], v.zoom);
}
